// extracted by mini-css-extract-plugin
module.exports = {"cost-saving-Q":"Q_cost-saving-Q__n5_6o"};